'use strict';

import angular from 'angular';
import Style from './style.controller';

export default angular.module('bfastCaptureManagerApp.application.style', [])
  .controller('AppStyleController', Style)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/style/index.js